import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import * as en from "./en";
import * as kr from "./kr";

const lng = "kr";

const resources: Resource = {
  en: {
    translation: {
      ...en.default,
    },
  },
  kr: {
    translation: {
      ...kr.default,
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: `${lng}`,
});

export default i18n;
